var map = {
	"./Kasala Banner_2020-01.png": 106,
	"./Kasala Banner_2020-02.png": 107,
	"./Kasala Banner_2020-03.png": 108,
	"./Kasala Banner_2020-04.png": 109,
	"./Kasala-imac-mockup_V1.jpg": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;